import { requestBase } from '@/apis/index';
import type { I } from '@/types/project';

export type EpAuthDataType = {
  /** 业务实际认证状态(1:未认证,2:认证中,3:认证通过,4:认证未通过) */
  epVerifyStatus?: 1 | 2 | 3 | 4;
  /** 企业认证状态(1:未认证,2:认证中,3:认证通过,4:认证未通过) */
  verify?: 1 | 2 | 3 | 4;
  /** 个人代付授权协议状态(-1:未提交,1:审核中,2:审核通过3:审核未通过) */
  personalPayAgreeStatus?: -1 | 1 | 2 | 3;
  /** 企业营业执照状态(-1:未提交,1:审核中,2:审核通过,3:审该未通过 */
  licensePicStatus?: -1 | 1 | 2 | 3;
  personalPayAgreePicPath?: string;
  personalPayAgreeDesc?: string;
  /** 客户属性(0:未知,1:企业,2:机构/个人 */
  epType?: 0 | 1 | 2;
  /** 交易频次(-1:异常,0:未知,1:低,2:中,3:高) */
  transactionFrequency?: -1 | 0 | 1 | 2 | 3;
  /** 是否签约中信银行 1已签约，0未签约 */
  isSignCiticbank?: 0 | 1;
  /**  1-个体工商户 2-其他 */
  epOrgType?: 1 | 2;
  // 个人实名认证状态（小b那边的）(1:认证通过,2:未通过)
  personVerifyStatus?: 1 | 2;
};

// 是否已完成个人代付协议认证
export function getEpAuthQuery(): Promise<I.ResponseStructure<EpAuthDataType>> {
  return requestBase('/eucSoa/epAuth/query', {
    method: 'get',
  });
}